import { useState, useEffect } from 'react';
import { userMedia } from 'utils';

const getMedia = async (myExactAudioDeviceId = '') => {
  try {
    if (myExactAudioDeviceId !== '') {
      return await userMedia({ audio: { deviceId: { exact: myExactAudioDeviceId } }, video: false });
    }
    return await userMedia({ audio: true, video: false });
  } catch (err) {
    return null;
  }
};

export default (id) => {
  const [audio, setAudio] = useState(null);
  useEffect(() => {
    if (!id) {
      return;
    }
    getMedia(id).then((stream) => {
      if (!stream) {
        return;
      }
      setAudio(stream);
    });
    return () => {
      if (audio) {
        audio.getTracks().forEach((track) => track.stop());
      }
      setAudio(null);
    };
  }, [id]);

  const [microphoneLevel, setMicrophoneLevel] = useState();

  useEffect(() => {
    if (audio) {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const audioContext = new AudioContext();

      const analyser = audioContext.createAnalyser();
      const microphone = audioContext.createMediaStreamSource(audio);
      const javascriptNode = audioContext.createScriptProcessor(2048, 1, 1);

      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 1024;

      microphone.connect(analyser);
      analyser.connect(javascriptNode);
      javascriptNode.connect(audioContext.destination);

      javascriptNode.onaudioprocess = () => {
        const array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        let values = 0;

        const { length } = array;
        for (let i = 0; i < length; i += 1) {
          values += array[i];
        }
        const average = values / length;
        setMicrophoneLevel(average / 1.3);
      };
      return () => {
        microphone.disconnect();
        analyser.disconnect(javascriptNode);
        javascriptNode.disconnect(audioContext.destination);
      };
    }
  }, [audio]);
  return { microphoneLevel };
};
